import { PendingStatusText, SuccessStatusText } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from './StatusValidationText.styles';

export interface StatusValidationTextProps {
  rule: boolean;
  id: string;
}

const StatusValidationText: FC<StatusValidationTextProps> = ({ rule, id }) => {
  const { t } = useTranslation('ChangePasswordSection');
  return (
    <StyledDiv>
      {rule ? (<SuccessStatusText id={id}>{t(id)}</SuccessStatusText>)
        : (<PendingStatusText id={id}>{t(id)}</PendingStatusText>)}
    </StyledDiv>
  );
};
export default StatusValidationText;
